import React from 'react';
import { Download } from 'lucide-react';

const BillingHistory = () => {
  const transactions = [
    {
      id: 1,
      date: '2024-03-01',
      description: 'Monthly Subscription',
      amount: 49.99,
      status: 'Paid',
      invoice: '#INV-001'
    },
    // Add more transactions
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm">
      <div className="p-6 border-b">
        <h2 className="text-xl font-semibold">Billing History</h2>
      </div>
      <div className="divide-y">
        {transactions.map(transaction => (
          <div key={transaction.id} className="p-6 flex items-center justify-between">
            <div>
              <p className="font-medium">{transaction.description}</p>
              <p className="text-sm text-gray-600">{transaction.date}</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="font-medium">${transaction.amount}</p>
                <p className="text-sm text-green-600">{transaction.status}</p>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full">
                <Download className="h-5 w-5 text-gray-600" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingHistory;